export default "__VITE_ASSET__B89wX2Ga__"